import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerOnboardingTaskCreateInput } from "@colab/shared";

export type AddOnboardingTaskInput = PartnerOnboardingTaskCreateInput & {
  partnerId: string;
};

// POST /api/partners/:id/onboarding
//
// Replaces revalidatePath("/admin/partners/${partnerId}") from
// /app/admin/partners/[id]/_actions.ts::addOnboardingTask.
export function useAddOnboardingTask() {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, AddOnboardingTaskInput>({
    mutationFn: ({ partnerId, ...body }) =>
      apiFetch<{ id: string }>(`/partners/${partnerId}/onboarding`, {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.onboarding(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
      // Sub-bucket 10 — admin overview aggregate carries openTasks count
      // and the first 4 open tasks for the Overview tab.
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.partners.overview(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to add task");
    },
  });
}
